import { Link } from "@tanstack/react-router";
import { useState, type FormEvent } from "react";
import { Button } from "../components/ui/button";
import { Field, Input } from "../components/ui/form";
import { authClient } from "../lib/auth-client";
import { AuthLayout } from "./auth-layout";

export function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [pending, setPending] = useState(false);
  const [sent, setSent] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setPending(true);
    await authClient.requestPasswordReset({
      email,
      redirectTo: `${window.location.origin}/reset-password`,
    });
    setPending(false);
    setSent(true);
  }

  return (
    <AuthLayout
      title="Reset password"
      description="We send a reset link to the address on the account."
      footer={
        <Link to="/login" className="hover:text-body">
          Back to sign in
        </Link>
      }
    >
      {sent ? (
        <p className="text-body text-ui leading-relaxed">
          If an account exists for {email}, a reset link is on its way. The link expires in one
          hour.
        </p>
      ) : (
        <form className="flex flex-col gap-3" onSubmit={submit}>
          <Field label="Email">
            <Input
              type="email"
              autoComplete="username"
              required
              value={email}
              onChange={(event) => setEmail(event.target.value)}
            />
          </Field>
          <Button type="submit" variant="primary" disabled={pending} className="mt-1">
            {pending ? "Sending…" : "Send reset link"}
          </Button>
        </form>
      )}
    </AuthLayout>
  );
}
